const columnDataSurveyResult = [
  {
    dataField: 'surveyResultNumId',
    caption: 'Номер результата опроса',
    dataType: 'number',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'surveyNumId',
    caption: 'Номер опроса',
    dataType: 'number',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'userId',
    caption: 'Id пользователя',
    dataType: 'number',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'userName',
    caption: 'Имя пользователя',
    dataType: 'string',
    notVisible: false,
    allowSearch: true,
    allowFiltering: true
  },
  {
    dataField: 'plantId',
    caption: 'Id склада',
    dataType: 'number',
    notVisible: true,
    allowSearch: false,
    allowFiltering: false
  },
  {
    dataField: 'plant',
    caption: 'Название склада',
    dataType: 'string',
    notVisible: false,
    allowSearch: true,
    allowFiltering: true
  },
  {
    dataField: 'rate',
    caption: 'оценка',
    dataType: 'number',
    notVisible: false,
    allowSearch: true,
    allowFiltering: true
  },
  {
    dataField: 'text',
    caption: 'Комментарий',
    dataType: 'string',
    notVisible: false,
    allowSearch: true,
    allowFiltering: true
  },
  {
    dataField: 'insertDatetime',
    caption: 'Дата прохождения опроса',
    dataType: 'date',
    notVisible: false,
    allowSearch: true,
    allowFiltering: true
  }
];

export default columnDataSurveyResult;
